import moment from "moment";
import platform from "Pub/js/platform";
import { langCheck } from "Pub/js/utils.js";
const { ajax, getLangCode, getTopWindow, formatDatetime, localTimeToServer } = platform;

const MarkType_Text = '1';
const MarkType_Image = '2';

const StyleType_Global = '0'; // 全局设置
const StyleType_Group = '1'; // 集团设置
const StyleType_App = '2'; // 报表应用设置
const fontFamilies = [
    {
        display: "仿宋",
        value: "FangSong",
    }, {
        display: "华文中宋",
        value: "STZhongsong",
    }, {
        display: "华文仿宋",
        value: "STFangsong",
    }, {
        display: "华文宋体",
        value: "STSong",
    }, {
        display: "华文彩云",
        value: "STCaiyun",
    }, {
        display: "华文新魏",
        value: "STXinwei",
    }, {
        display: "华文琥珀",
        value: "STHupo",
    }, {
        display: "华文行楷",
        value: "STXingkai",
    }, {
        display: "华文楷体",
        value: "STKaiti",
    }, {
        display: "华文细黑",
        value: "STXihei",
    }, {
        display: "华文隶书",
        value: "STLiti",
    }, {
        display: "宋体",
        value: "SimSun",
    }, {
        display: "幼圆",
        value: "YouYuan",
    }, {
        display: "微软雅黑",
        value: "Microsoft YaHei",
    }, {
        display: "微软雅黑 Light",
        value: "Microsoft JhengHei",
    }, {
        display: "新宋体",
        value: "NSimSun",
    }, {
        display: "方正姚体",
        value: "FZYaoti",
    }, {
        display: "方正舒体",
        value: "FZShuTi",
    }, {
        display: "楷体",
        value: "KaiTi",
    }, {
        display: "隶书",
        value: "LiSu",
    }, {
        display: "黑体",
        value: "SimHei",
    }, {
        display: "Arial",
        value: "Arial",
    }, {
        display: "Arial Black",
        value: "Arial Black",
    }, {
        display: "Arial Narrow",
        value: "Arial Narrow",
    }, {
        display: "Comic Sans MS",
        value: "Comic Sans MS",
    }, {
        display: "Courier New",
        value: "Courier New",
    }, {
        display: "Verdana",
        value: "Verdana",
    }, {
        display: "Georgia",
        value: "Georgia",
    }, {
        display: "Times New Roman",
        value: "Times New Roman",
    }, {
        display: "Trebuchet MS",
        value: "Trebuchet MS",
    }, {
        display: "Impact",
        value: "Impact",
    }, {
        display: "Tahoma",
        value: "Tahoma",
    }, {
        display: "Courier",
        value: "Courier",
    }, {
        display: "Lucida Sans Unicode",
        value: "Lucida Sans Unicode",
    }, {
        display: "Lucida Console",
        value: "Lucida Console",
    }, {
        display: "Garamond",
        value: "Garamond",
    }, {
        display: "MS Sans Serif",
        value: "MS Sans Serif",
    }, {
        display: "MS Serif",
        value: "MS Serif",
    },
];

const fontSizes = [
    {
        display: 10,
        value: 10,
    }, {
        display: 12,
        value: 12,
    }, {
        display: 14,
        value: 14,
    }, {
        display: 16,
        value: 16,
    }, {
        display: 18,
        value: 18,
    }, {
        display: 24,
        value: 24,
    // }, {
    //     display: 36,
    //     value: 36,
    // }, {
    //     display: 48,
    //     value: 48,
    // }, {
    //     display: 72,
    //     value: 72,
    },
];

const rotateArr = [
    { value: '45', display: 45 },
    { value: '-45', display: -45 },
    { value: '0', display: '无' },
    { value: 'custom', display: '自定义', min: -180, max: 180, step: 1 },
];

const queryLanguage = params => {
    return new Promise(resolve => {
        ajax({
            url: '/nccloud/platform/appregister/querylanguagevos.do',
            data: params || {},
            success: ({ data }) => {
                if (data && data.length > 0) {
                    /**
                     * 前端组合成多语文本可以支持的options
                     */
                    let multiOptions = data.map((item, index) => {
                        let itemIndex = ++index;
                        let multiItem = {
                            index: "",
                            languageType: "zh",
                            languageCode: "simpchn",
                        };
                        multiItem.index = itemIndex > 1 ? multiItem.index + itemIndex : "";
                        multiItem.languageType = item.locallang;
                        multiItem.languageCode = item.langcode;
                        multiItem.languageMain = item.langseq == "1" ? true : false;
                        return multiItem;
                    });
                    resolve(multiOptions);
                }
            },
        });
    });
};

const getMultiLangDisplayText = (data, propertyKey, multiOptions) => {
    let local = getLangCode('langCode');
    let localText = '';
    let mainText = data && data[propertyKey] || '';
    let itemKey = propertyKey;
    let ret;
    if (!multiOptions) {
        return _.get(data, itemKey, '');
    }
    multiOptions.forEach(opt => {
        let { index, languageCode } = opt;
        itemKey = `${propertyKey}${index}`;
        if (languageCode === local) {
            localText = _.get(data, itemKey);
        }
    });
    ret = localText && localText.length > 0 ? localText : mainText;
    return ret;
};

function hexToRGBA(hex = '', opacity) {
    const values = hex.match(/\w\w/g);
    if (!values) {return '';}
    const [r, g, b] = values.map(k => parseInt(k, 16));
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

export function getWatermarkImageSet(watermarkSetting) {
    return new Promise(resolve => {
        const { marktype, marktpl = [], markimg, fontfamily, fontsize, fontcolor, fontbold, fontitalic, rotate, customrotate, opacity, density } = watermarkSetting;
        if (!markimg) {
            return resolve({});
        }
        let width = 120;
        let height = 64;
        let img = document.createElement('img');
        img.src = markimg;
        img.addEventListener('load', e => {
            width = e.target.width;
            height = e.target.height;
            // let max = Math.max(width, height);
            const curRotate = rotate === 'custom' ? customrotate : rotate;
            // let curColGap = 0;
            // let curRowGap = 0;
            // curRowGap = Math.abs(Math.sin(Math.PI / 180 * curRotate)) * max;
            // curColGap = Math.abs(Math.cos(Math.PI / 180 * curRotate)) * max;
            let cosA = Math.abs(Math.cos(Math.PI / 180 * curRotate));
            let sinA = Math.abs(Math.sin(Math.PI / 180 * curRotate));
            let curColGap = Math.max(cosA * width, cosA * height);
            let curRowGap = Math.max(sinA * width, sinA * height);

            let newImage = processImageOpacity(e.target, opacity);

            // const img1 = new Image();
            // img1.src = newImage;
            // img1.style.position = 'fixed';
            // img1.style.top = '0px';
            // img1.style.zIndex = 9999;
            // document.body.appendChild(img1);

            resolve({
                width: width * 2, 
                height: height * 2,
                originWidth: width,
                originHeight: height,
                // image: markimg, 
                image: newImage,
                // gap: [curColGap + 100 - density, curRowGap + 100 - density],
                gap: [200 - density, 200 - density],
                opacity, 
            });
        });
        img.addEventListener('error', e => {
            resolve({});
        });
    });
}

function processImageOpacity(imgEl, opacity) {
    const { width, height } = imgEl;
    const canvas = document.createElement('canvas');
    // document.body.appendChild(canvas);
    // canvas.style.position = 'fixed';
    // canvas.style.top = '0px';
    // canvas.style.zIndex = 9999;
    // canvas.style.border = '1px solid red';
    const ctx = canvas.getContext('2d');
    canvas.width = width * 2;
    canvas.height = height * 2;
    ctx.drawImage(imgEl, width / 2, height / 2, width, height);
    // canvas.width = width;
    // canvas.height = height;
    // ctx.drawImage(imgEl, 0, 0, width, height);
    // 获取像素数组
    let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    // 遍历像素点
    for (let i = 0; i < imageData.data.length; i += 4) {
        // 修改像素点透明度
        imageData.data[i + 3] *= opacity;
    }
    // 输出图像
    ctx.putImageData(imageData, 0, 0);
    const dataURL = canvas.toDataURL();
    canvas.remove();
    return dataURL;
}

// blob转base64
function blobToDataURI(blob, callback) {
    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = function (e) {
        callback(e.target.result);
    };
}

function getWatermarkContentSet(watermarkSetting, multiLangOptions, json) {
    const { marktype, marktpl = [], markimg, fontfamily, fontsize, fontcolor, fontbold, fontitalic, rotate, customrotate, opacity, density } = watermarkSetting;
    const curRotate = rotate === 'custom' ? customrotate : rotate;
    if (!marktpl || marktpl.length === 0) {
        return Promise.resolve({});
    }
    let content = marktpl.map(el => {
        let ret = getSysVar(el, multiLangOptions, json);
        if (el.isWrap) {
            ret = '\n' + ret;
        }
        return ret;
    });

    if (marktype !== MarkType_Text) {
        content = [];
    }

    content = content.join(' ');
    // const contentSize = getContentSize(content, fontsize, fontfamily, fontbold, fontitalic);
    // let contentWidth = contentSize.width;
    // let contentHeight = contentSize.height;
    content = content.split('\n');
    return Promise.resolve({
        content,
        // width: contentWidth,
        // height: contentHeight,
        // gap: [colGap + 100 - density, rowGap + 100 - density],
        gap: [200 -density, 200 -density],
    });
}

function getSysVar(item, multiLangOptions, json) {
    // const { companyStyleSettingObj } = this.props;
    // const { multiLangOptions } = companyStyleSettingObj;
    // const { multiLangOptions } = this.state;
    const { code } = item;
    let ret = '';
    let businessInfo = getTopWindow().GETBUSINESSINFO();
    const sysDateTime = localTimeToServer(moment(Date.now()), '1'); // 服务器时间
    const emptyMsg = (name, json) => {
        let s = langCheck('Watermark-000057', 'WatermarkSetting', json);
        return name + s;
    };
    switch(code) {
        case '&[sysdate]': // 系统日期
            ret = formatDatetime(sysDateTime, 'date') || formatDatetime(new Date().toLocaleDateString(), 'date');
            break;
        case '&[systime]': // 系统时间
            ret = formatDatetime(sysDateTime, 'time') || new Date().toLocaleTimeString();
            break;
        case '&[bisdate]': // 业务日期
            ret = formatDatetime(businessInfo.businessDate, 'date') || emptyMsg(langCheck('Watermark-000030', 'WatermarkSetting', json), json);
            break;
        case '&[clientdate]': // 客户端日期
            ret = formatDatetime(new Date().toLocaleDateString(), 'date') || emptyMsg(langCheck('Watermark-000031', 'WatermarkSetting', json), json);
            break;
        case '&[clienttime]': // 客户端时间
            ret = formatDatetime(new Date().toLocaleString(), 'time') || emptyMsg(langCheck('Watermark-000045', 'WatermarkSetting', json), json);
            break;
        case '&[group]': // 集团名称
            ret = businessInfo.groupName || emptyMsg(langCheck('Watermark-000032', 'WatermarkSetting', json), json);
            break;
        case '&[busiunit]': // 人员所属业务单元
            // ret = langCheck('Watermark-000033', json); 
            ret = businessInfo.psndoc_org_name || emptyMsg(langCheck('Watermark-000033', 'WatermarkSetting', json), json); // '人员所属业务单元'
            break;
        case '&[department]': // 主职部门
            // ret = langCheck('Watermark-000048', json); // 主职部门
            ret = businessInfo.deptName || emptyMsg(langCheck('Watermark-000048', 'WatermarkSetting', json), json); // '主职部门'
            break;
        case '&[personname]': // 人员名称
            // ret = langCheck('Watermark-000049', json); // 人员名称
            ret = businessInfo.psndocName || emptyMsg(langCheck('Watermark-000049', 'WatermarkSetting', json), json); // '人员名称'.
            break;
        case '&[user]': // 用户名称
            ret = businessInfo.userName || emptyMsg(langCheck('Watermark-000034', 'WatermarkSetting', json), json);
            break;
        case '&[userid]': // 用户编码
            ret = businessInfo.userCode || emptyMsg(langCheck('Watermark-000035', 'WatermarkSetting', json), json);
            break;
        case '&[useremail]': // 用户邮箱
            ret = businessInfo.watermark_mail || emptyMsg(langCheck('Watermark-000036', 'WatermarkSetting', json), json);
            break;
        case '&[usercell]': // 用户手机号
            ret = businessInfo.watermark_mobile || emptyMsg(langCheck('Watermark-000037', 'WatermarkSetting', json), json);
            break;
        case '&[deftext]': // 自定义文本
            ret = getMultiLangDisplayText(item, 'value', businessInfo.languageMetas);
            break;

        default:
            ret = code;
            break;
    }
    return ret;
}

function getContentSize (text, fontsize, fontfamily, fontbold, fontitalic) {
    // let span = document.createElement('span');
    // span.style.fontSize = `${fontsize}px`;
    // span.style.fontFamily = fontfamily;
    // span.style.fontWeight = fontbold ? 'bold' : 'normal';
    // span.style.fontStyle = fontitalic ? 'italic' : 'normal';
    // span.position = 'fixed';
    // span.top = '-9999px';
    // span.innerText = text;
    // document.body.appendChild(span);
    // let width = span.getBoundingClientRect().width;
    // let height = span.getBoundingClientRect().height;
    // document.body.removeChild(span);
    // return { width, height };

    let canvas = document.createElement('canvas');
    document.body.appendChild(canvas);
    let ctx = canvas.getContext('2d');
    ctx.font = `${fontbold ? 'bold' : ''} ${fontitalic ? 'italic' : ''} ${fontsize}px ${fontfamily}`;
    let multiLine = text.split('\n');
    let x = 0; 
    let y = 0;
    let maxWidth = 0;
    let maxHeight = 0;
    for (let i = 0; i < multiLine.length; i++) {
        let metrics = ctx.measureText(multiLine[i]);
        let lineHeight = metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent;
        let lineWidth = metrics.actualBoundingBoxRight - metrics.actualBoundingBoxLeft;
        y += lineHeight;
        maxWidth = lineWidth > maxWidth ? lineWidth : maxWidth;
        if (lineWidth > 0) {
            maxHeight += lineHeight;
        }
        ctx.fillText(multiLine[i], x, y);
    }
    console.log(`contentsize: `, maxWidth, maxHeight);
    // document.body.removeChild(canvas);
    return { width: maxWidth, height: maxHeight };
}

function calcWaterMarkPreviewConfig(watermarkSetting, multiLangOptions, json) {
    const { marktype, marktpl = [], markimg, fontfamily, fontsize, fontcolor, fontbold, fontitalic, rotate, customrotate, opacity, density } = watermarkSetting;
    const curRotate = rotate === 'custom' ? customrotate : rotate;

    let watermarkProps = {
        rotate: curRotate,
        font: {
            color: hexToRGBA(fontcolor, opacity),
            fontSize: fontsize,
            // fontWeight: fontbold ? 'weight' : 'normal',
            fontWeight: fontbold ? '700' : 'normal',
            fontFamily: fontfamily,
            fontStyle: fontitalic ? 'italic' : 'normal',
        },

    };
    let getMarkSetting = marktype === MarkType_Image ? getWatermarkImageSet(watermarkSetting) : getWatermarkContentSet(watermarkSetting, multiLangOptions, json);
    
    return getMarkSetting.then(setting => {
        return {
            ...watermarkProps,
            ...setting,
        };
    });
}

function formatWatermarkPreviewConfig(watermarkSetting, multiLangOptions, json) {
    const { marktype, marktpl = [], markimg, fontfamily, fontsize, fontcolor, fontbold, fontitalic, rotate, customrotate, opacity, density } = watermarkSetting;
    let watermarkProps = {
        rotate: rotate,
        font: {
            color: hexToRGBA(fontcolor, opacity),
            fontSize: fontsize,
            fontWeight: fontbold ? 'bold' : 'normal',
            fontFamily: `${fontfamily} sans-serif`,
            fontStyle: fontitalic ? 'italic' : 'normal',
        },
    };
    let getMarkSetting = marktype === MarkType_Image ? getWatermarkImageSet(watermarkSetting) : getWatermarkContentSet(watermarkSetting, multiLangOptions, json);
    return getMarkSetting.then(setting => {
        return {
            ...watermarkProps,
            ...setting,
        };
    });

}

export {
    MarkType_Text,
    MarkType_Image,
    StyleType_Global,
    StyleType_Group,
    StyleType_App,
    fontFamilies,
    fontSizes,
    rotateArr,
    queryLanguage,
    getMultiLangDisplayText,
    langCheck,
    calcWaterMarkPreviewConfig,
    formatWatermarkPreviewConfig,
    blobToDataURI,
};